export default __webpack_public_path__ + "static/media/EM0630.34I-22021_-15007_0.7c617738.jpg";